import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FaUser,
  FaMapMarkerAlt,
  FaStickyNote,
  FaUsers,
  FaFileExcel,
  FaSave,
  FaRedo,
  FaTimes,
} from "react-icons/fa";

import Layout from "../layout/Layout";
import "./AddContact.css";

const API = "https://data.shreemwell.in/api/contacts";

const initialForm = {
  firstName: "",
  lastName: "",
  nickname: "",
  mobile: "",
  alternateMobile: "",
  whatsappNumber: "",
  email: "",
dateOfBirth: "",
  currentLocation: "",
  workLocation: [],
  whichLocation: [],
  contactLevel: "",
  relationType:"",

  personalNote: "",
  publicNote: "",
  

  upline: "",
  uplineName: "",
  uplineCode: "",

  saoName: "",
  saoCode: "",

  sgoName: "",
  sgoCode: "",

  ssgName: "",
  ssgCode: "",
};

const AddContact = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [activeField, setActiveField] = useState("");
  const [excelFile, setExcelFile] = useState(null);

  const [formData, setFormData] = useState(initialForm);
  const [sameAsMobile, setSameAsMobile] = useState(false);
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [errors, setErrors] = useState({});


  const validateForm = () => {
  const newErrors = {};

  // First Name
  if (formData.firstName && !/^[A-Za-z ]{2,50}$/.test(formData.firstName.trim())) {
    newErrors.firstName =
      "First name should contain only letters (2-50 characters).";
  }

  // Last Name
  if (formData.lastName && !/^[A-Za-z ]{2,50}$/.test(formData.lastName.trim())) {
    newErrors.lastName =
      "Last name should contain only letters (2-50 characters).";
  }

  // Nickname
  if (formData.nickname && formData.nickname.length > 30) {
    newErrors.nickname = "Nickname should not exceed 30 characters.";
  }

  // Mobile (Required)
  if (!formData.mobile.trim()) {
    newErrors.mobile = "Mobile Number is required.";
  } else if (!/^[6-9]\d{9}$/.test(formData.mobile.trim())) {
    newErrors.mobile = "Enter a valid 10-digit Indian mobile number.";
  }

  // Alternate Mobile
  if (
    formData.alternateMobile &&
    !/^[6-9]\d{9}$/.test(formData.alternateMobile.trim())
  ) {
    newErrors.alternateMobile =
      "Enter a valid 10-digit alternate mobile number.";
  }

  // WhatsApp
  if (
    formData.whatsappNumber &&
    !/^[6-9]\d{9}$/.test(formData.whatsappNumber.trim())
  ) {
    newErrors.whatsappNumber =
      "Enter a valid 10-digit WhatsApp number.";
  }

  // Email
  if (
    formData.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email.trim())
  ) {
    newErrors.email = "Enter a valid email address.";
  }

  // Personal Note
if (formData.personalNote.length > 500) {
  newErrors.personalNote =
    "Personal note should not exceed 500 characters.";
}

// Public Note
if (formData.publicNote.length > 500) {
  newErrors.publicNote =
    "Public note should not exceed 500 characters.";
}





  

  // Personal Note
  if (formData.personalNote.length > 500) {
    newErrors.personalNote =
      "Personal note should not exceed 500 characters.";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};

// const checkExistingContact = async (mobile) => {
//   if (!/^[6-9]\d{9}$/.test(mobile)) return;

//   try {
//     const token = localStorage.getItem("token");

//     const res = await axios.post(
//       `${API}/check-mobile`,
//       { mobile },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     if (res.data.exists) {
//       toast.dismiss();

//       toast.error("This mobile number is already registered.");

//       setFormData((prev) => ({
//         ...prev,
//         mobile: "",
//       }));
//     }
//   } catch (err) {
//     console.log(err);
//   }
// };
  const searchLocation = async (query, field) => {
    if (!query || query.length < 2) {
      setSuggestions([]);
      return;
    }

    try {
      const res = await fetch(
        `https://photon.komoot.io/api/?q=${encodeURIComponent(query)}&limit=10`
      );

      const data = await res.json();

      const uniqueCities = [
        ...new Set(
          data.features
            .filter((item) => item.properties.country === "India")
            .map(
              (item) =>
                item.properties.city ||
                item.properties.name ||
                item.properties.state
            )
            .filter(Boolean)
        ),
      ];

      setSuggestions(uniqueCities);
      setActiveField(field);
    } catch (err) {
      console.log(err);
    }
  };

  const selectLocation = (city) => {
    setFormData((prev) => {
      if (activeField === "workLocation") {
        if (prev.workLocation.includes(city)) return prev;

        return {
          ...prev,
          workLocation: [...prev.workLocation, city],
        };
      }

      if (activeField === "whichLocation") {
        if (prev.whichLocation.includes(city)) return prev;

        return {
          ...prev,
          whichLocation: [...prev.whichLocation, city],
        };
      }

      return {
        ...prev,
        [activeField]: city,
      };
    });

    setSuggestions([]);
    setActiveField("");
  };



  // ----------------------------
  // Handle Input
  // ----------------------------


const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => {
    const updated = {
      ...prev,
      [name]: value,
    };

    if (name === "mobile" && sameAsMobile) {
      updated.whatsappNumber = value;
    }

    return updated;
  });

  // Check duplicate immediately when 10 digits are entered
  // if (name === "mobile" && /^[6-9]\d{9}$/.test(value)) {
  //   checkExistingContact(value);
  // }
};
  const handleSameAsMobile = (e) => {
    const checked = e.target.checked;

    setSameAsMobile(checked);

    setFormData((prev) => ({
      ...prev,
      whatsappNumber: checked ? prev.mobile : "",
    }));
  };

  // ----------------------------
  // Reset Form
  // ----------------------------

  const handleReset = () => {
    setFormData(initialForm);
  };

  // ----------------------------
  // Save Contact
  // ----------------------------

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) {
    toast.error("Please fix the validation errors.");
    return;
  }

  try {
    setLoading(true);

    const token = localStorage.getItem("token");

    const res = await axios.post(API, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    toast.success(res.data.message);

    setTimeout(() => {
      navigate("/ContactMangement");
    }, 1000);

  } catch (err) {
    console.error(err);

    toast.error(
      err.response?.data?.message ||
      "Unable to save contact."
    );
  } finally {
    setLoading(false);
  }
};
  // ----------------------------
  // Upload Excel
  // ----------------------------

 const uploadExcel = async () => {
  if (!excelFile) {
    toast.error("Please select an Excel file.");
    return;
  }

  try {
    setUploading(true);

    const data = new FormData();
    data.append("file", excelFile);

 const token = localStorage.getItem("token");

const res = await axios.post(`${API}/import`, data, {
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
  },
});

    toast.success(res.data.message || "Excel uploaded successfully.");
    setExcelFile(null);

  } catch (err) {
    console.error(err);

    toast.error(
      err.response?.data?.message ||
      "Excel upload failed."
    );
  } finally {
    setUploading(false);
  }
};



  return (
    <Layout>
       <ToastContainer
    position="top-right"
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop
    closeOnClick
    pauseOnHover
    draggable
    theme="colored"
  />

      <div className="contact-page">

        {/* ========================= */}
        {/* PAGE HEADER */}
        {/* ========================= */}

        <div className="page-header">

          <div>

            <h2>Add New Contact</h2>

            <p>
              Create a contact manually or import
              multiple contacts using an Excel file.
            </p>

          </div>

        </div>

        {/* ========================= */}
        {/* IMPORT EXCEL CARD */}
        {/* ========================= */}

        <div className="card">

          <div className="card-title">

            <FaFileExcel />

            <span>Import Contacts</span>

          </div>

          <div className="excel-grid">

            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={(e) =>
                setExcelFile(e.target.files[0])
              }
            />

            <button
              type="button"
              className="upload-btn"
              disabled={uploading}
              onClick={uploadExcel}
            >
              {uploading
                ? "Uploading..."
                : "Upload Excel"}
            </button>

          </div>

        </div>

        {/* ========================= */}
        {/* FORM START */}
        {/* ========================= */}

        <form onSubmit={handleSubmit}>

          {/* ========================= */}
          {/* BASIC INFORMATION */}
          {/* ========================= */}

          <div className="card">

            <div className="card-title">

              <FaUser />

              <span>Basic Information</span>

            </div>


            <div className="form-grid">

              {/* First Name */}
              <div className="form-group">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="Enter first name"
                />
              </div>

              {/* Last Name */}
              <div className="form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Enter last name"
                />
              </div>

              {/* Nickname */}
              <div className="form-group">
                <label>Nickname</label>
                <input
                  type="text"
                  name="nickname"
                  value={formData.nickname}
                  onChange={handleChange}
                  placeholder="Enter nickname"
                />
              </div>

              {/* Date of Birth */}
<div className="form-group">
  <label>Date of Birth</label>
  <input
    type="date"
    name="dateOfBirth"
    value={formData.dateOfBirth}
    onChange={handleChange}
    max={new Date().toISOString().split("T")[0]}
  />
</div>
 {/* Email */}
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="example@gmail.com"
                />
                {errors.email && (
  <small className="error-text">{errors.email}</small>
)}
              </div>
              {/* Mobile */}
              <div className="form-group">
                <label>Mobile Number *</label>
               <input
  type="text"
  name="mobile"
  value={formData.mobile}
  onChange={handleChange}

  placeholder="9876543210"
  required
/>
                {errors.mobile && (
  <small className="error-text">{errors.mobile}</small>
)}

              </div>

              {/* Alternate */}
              <div className="form-group">
                <label>Alternate Mobile</label>
                <input
                  type="text"
                  name="alternateMobile"
                  value={formData.alternateMobile}
                  onChange={handleChange}
                  placeholder="Alternate number"
                />
               {errors.alternateMobile && (
  <small className="error-text">{errors.alternateMobile}</small>
)}
              </div>

              {/* WhatsApp */}
              <div className="form-group">
                <label>WhatsApp Number</label>



                <input
                  type="text"
                  name="whatsappNumber"
                  value={formData.whatsappNumber}
                  onChange={handleChange}
                  placeholder="WhatsApp number"
                  disabled={sameAsMobile}
                />
                <div className="checkbox-inline">
                  <input
                    type="checkbox"
                    id="sameAsMobile"
                    checked={sameAsMobile}
                    onChange={handleSameAsMobile}
                  />
                  

                  <label htmlFor="sameAsMobile" className="checkbox-label">
                    Same as Mobile Number
                  </label>
                  
                </div>
                 {errors.mobile && (
  <small className="error-text">{errors.whatsappNumber}</small>
)}
              </div>

            
              {/* Contact Level */}
              <div className="form-group">
                <label>Relationship Level</label>

                <select
                  name="contactLevel"
                  value={formData.contactLevel}
                  onChange={handleChange}
                >
                      <option value="">Relationship Level</option>
                  <option value="Relative">Relative</option>
                  <option value="Friend">Friend</option>
                  <option value="Colleague">Colleague</option>
                  <option value="Neighbour">Neighbour</option>
                  <option value="Society friend">Society friend</option>
                  <option value="From group">From group</option>

                </select>
              </div>



<div className="form-group">
  <label>Relation Type</label>

  <select
    name="relationType"
    value={formData.relationType}
    onChange={handleChange}
  >
    <option value="">Select Relation Type</option>
    <option value="Between persons">Between persons</option>
    <option value="Only user">Only user</option>
    <option value="Only partner">Only partner</option>
    {/* <option value="Neighbour">Neighbour</option> */}
   
  </select>
</div>

            </div>

          </div>



          {/* ========================= */}
          {/* LOCATION DETAILS */}
          {/* ========================= */}

          <div className="card">
            <div className="card-title">
              <FaMapMarkerAlt />
              <span>Location Details</span>
            </div>

            <div className="form-grid">

              {/* Current Location */}
              <div className="form-group">
                <label>Current Location</label>

                <div className="location-box">
                  <input
                    className="single-location-input"
                    type="text"
                    value={formData.currentLocation}
                    placeholder="Search current city..."
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        currentLocation: e.target.value,
                      });

                      searchLocation(e.target.value, "currentLocation");
                    }}
                  />

                  {activeField === "currentLocation" &&
                    suggestions.length > 0 && (
                      <ul className="location-list">
                        {suggestions.map((city) => (
                          <li
                            key={city}
                            onClick={() => selectLocation(city)}
                          >
                            <FaMapMarkerAlt className="location-icon" />
                            {city}
                          </li>
                        ))}
                      </ul>
                    )}
                </div>
              </div>

              {/* Work Location */}
              <div className="form-group">
                <label>Work Location</label>

                <div className="location-box">

                  {/* Search Input */}
                  <input
                    type="text"
                    className="single-location-input"
                    placeholder="Search work city..."
                    onChange={(e) =>
                      searchLocation(e.target.value, "workLocation")
                    }
                  />

                  {/* Selected Cities */}

                  <div className="selected-wrapper">

                    <div className="selected-location-scroll">
                      {
                        formData.workLocation.map((city) => (
                          <div className="city-chip" key={city}>
                            <span>{city}</span>

                            <button
                              type="button"
                              onClick={() =>
                                setFormData(prev => ({
                                  ...prev,
                                  workLocation:
                                    prev.workLocation.filter(x => x !== city)
                                }))
                              }
                            >
                              ×
                            </button>

                          </div>
                        ))
                      }
                    </div>

                  </div>

                  {activeField === "workLocation" &&
                    suggestions.length > 0 && (
                      <ul className="location-list">
                        {suggestions.map((city) => (
                          <li
                            key={city}
                            onClick={() => selectLocation(city)}
                          >
                            <FaMapMarkerAlt className="location-icon" />
                            {city}
                          </li>
                        ))}
                      </ul>
                    )}

                </div>
              </div>

              <div className="form-group">
                <label>Wish Location</label>

                <div className="location-box">

                  {/* Search Input */}
                  <input
                    type="text"
                    className="single-location-input"
                    placeholder="Search Wish city..."
                    onChange={(e) =>
                      searchLocation(e.target.value, "whichLocation")
                    }
                  />

                  {/* Selected Cities */}
                  <div className="selected-location-scroll">
                    {formData.whichLocation.map((city) => (
                      <div className="city-chip" key={city}>
                        <span>{city}</span>

                        <button
                          type="button"
                          onClick={() =>
                            setFormData((prev) => ({
                              ...prev,
                              whichLocation: prev.whichLocation.filter(
                                (x) => x !== city
                              ),
                            }))
                          }
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>

                  {activeField === "whichLocation" &&
                    suggestions.length > 0 && (
                      <ul className="location-list">
                        {suggestions.map((city) => (
                          <li
                            key={city}
                            onClick={() => selectLocation(city)}
                          >
                            <FaMapMarkerAlt className="location-icon" />
                            {city}
                          </li>
                        ))}
                      </ul>
                    )}

                </div>
              </div>


            </div>
          </div>

          {/* ========================= */}
          {/* PERSONAL NOTE */}
          {/* ========================= */}

       

<div className="card">
  <div className="card-title">
    <FaStickyNote />
    <span>Notes</span>
  </div>

  <div className="notes-grid">
    {/* Personal Note */}
    <div className="form-group">
      <label>Personal Note</label>

      <textarea
        rows={3}
        name="personalNote"
        value={formData.personalNote}
        onChange={handleChange}
        placeholder="Write personal note..."
        className="textarea notes-textarea"
      />

      {errors.personalNote && (
        <small className="error-text">
          {errors.personalNote}
        </small>
      )}
    </div>

    {/* Public Note */}
    <div className="form-group">
      <label>Public Note</label>

      <textarea
        rows={3}
        name="publicNote"
        value={formData.publicNote}
        onChange={handleChange}
        placeholder="Write public note..."
        className="textarea notes-textarea"
      />

      {errors.publicNote && (
        <small className="error-text">
          {errors.publicNote}
        </small>
      )}
    </div>
  </div>
</div>


        {/* ========================= */}
{/* TEAM DETAILS */}
{/* ========================= */}

<div className="card">

  <div className="card-title">
    <FaUsers />
    <span>Team Details</span>
  </div>

  <table className="team-details-table">

    <thead>
      <tr>
        <th style={{ width: "28%" }}>Relationship</th>
        <th>Name</th>
        <th style={{ width: "25%" }}>Code</th>
      </tr>
    </thead>

    <tbody>

      {/* Upline */}
      <tr>

        <td>
          <div className="relationship-box">

            <span>Upline</span>

            <select
              name="upline"
              value={formData.upline}
              onChange={handleChange}
            >
              <option value="">Select</option>
              <option value="SAO">SAO</option>
              <option value="SGO">SGO</option>
            </select>

          </div>
        </td>

        <td>
          <input
            type="text"
            name="uplineName"
            value={formData.uplineName}
            onChange={handleChange}
            placeholder="Enter Upline Name"
          />
        </td>

        <td>
          <input
            type="text"
            name="uplineCode"
            value={formData.uplineCode}
            onChange={handleChange}
            placeholder="Enter Upline Code"
          />
          {errors.uplineCode && (
            <small className="error-text">{errors.uplineCode}</small>
          )}
        </td>

      </tr>

      {/* Downline SAO */}
      <tr>

        <td className="relation-label">
          Downline SAO
        </td>

        <td>
          <input
            type="text"
            name="saoName"
            value={formData.saoName}
            onChange={handleChange}
            placeholder="Enter SAO Name"
          />
          {errors.saoName && (
            <small className="error-text">{errors.saoName}</small>
          )}
        </td>

        <td>
          <input
            type="text"
            name="saoCode"
            value={formData.saoCode}
            onChange={handleChange}
            placeholder="Enter SAO Code"
          />
          {errors.saoCode && (
            <small className="error-text">{errors.saoCode}</small>
          )}
        </td>

      </tr>

      {/* Downline SGO */}
      <tr>

        <td className="relation-label">
          Downline SGO
        </td>

        <td>
          <input
            type="text"
            name="sgoName"
            value={formData.sgoName}
            onChange={handleChange}
            placeholder="Enter SGO Name"
          />
          {errors.sgoName && (
            <small className="error-text">{errors.sgoName}</small>
          )}
        </td>

        <td>
          <input
            type="text"
            name="sgoCode"
            value={formData.sgoCode}
            onChange={handleChange}
            placeholder="Enter SGO Code"
          />
          {errors.sgoCode && (
            <small className="error-text">{errors.sgoCode}</small>
          )}
        </td>

      </tr>

    </tbody>

  </table>

</div>

          {/* ========================= */}
          {/* ACTION BUTTONS */}
          {/* ========================= */}

          <div className="button-section">

            <button
              type="button"
              className="btn btn-cancel"
              onClick={() => navigate("/ContactMangement")}
            >
              <FaTimes />
              <span className="btn-con" >Cancel</span>
            </button>

            <button
              type="button"
              className="btn btn-reset"
              onClick={handleReset}
            >
              <FaRedo />
              <span className="btn-con">Reset</span>
            </button>

            <button
              type="submit"
              className="btn btn-save"
              disabled={loading}
            >
              <FaSave />

              <span className="btn-con">
                {loading ? "Saving..." : "Save Contact"}
              </span>
            </button>

          </div>

        </form>

      </div>

    </Layout>

  );
};

export default AddContact;
